import { render, staticRenderFns } from "./SearchDinamicField.vue?vue&type=template&id=70dc13da&"
import script from "./SearchDinamicField.vue?vue&type=script&lang=js&"
export * from "./SearchDinamicField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports